import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

export default function PHProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
